/* tslint:disable */
/* eslint-disable */
/**
 * Dataland QA Service API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { PreApprovalConfig } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { PreApprovalConfigPatchRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
// @ts-ignore
import type { PreApprovalConfigPutRequest } from '../../../../../../org/dataland/datalandfrontend/openApiClient/qaservice/model';
/**
 * PreApprovalControllerApi - axios parameter creator
 */
export const PreApprovalControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the current pre-approval configuration.
         * @summary Get the current pre-approval configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreApprovalConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pre-approval/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Partially updates the pre-approval configuration. Only the provided fields are changed. The sampling probability must be between 0.0 and 1.0.
         * @summary Update the pre-approval configuration.
         * @param {PreApprovalConfigPatchRequest} preApprovalConfigPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPreApprovalConfig: async (preApprovalConfigPatchRequest: PreApprovalConfigPatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preApprovalConfigPatchRequest' is not null or undefined
            assertParamExists('patchPreApprovalConfig', 'preApprovalConfigPatchRequest', preApprovalConfigPatchRequest)
            const localVarPath = `/pre-approval/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preApprovalConfigPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fully replaces the pre-approval configuration with the provided one. All fields are required. The sampling probability must be between 0.0 and 1.0.
         * @summary Replace the pre-approval configuration.
         * @param {PreApprovalConfigPutRequest} preApprovalConfigPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPreApprovalConfig: async (preApprovalConfigPutRequest: PreApprovalConfigPutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'preApprovalConfigPutRequest' is not null or undefined
            assertParamExists('putPreApprovalConfig', 'preApprovalConfigPutRequest', preApprovalConfigPutRequest)
            const localVarPath = `/pre-approval/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preApprovalConfigPutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PreApprovalControllerApi - functional programming interface
 */
export const PreApprovalControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PreApprovalControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the current pre-approval configuration.
         * @summary Get the current pre-approval configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPreApprovalConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreApprovalConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPreApprovalConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreApprovalControllerApi.getPreApprovalConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Partially updates the pre-approval configuration. Only the provided fields are changed. The sampling probability must be between 0.0 and 1.0.
         * @summary Update the pre-approval configuration.
         * @param {PreApprovalConfigPatchRequest} preApprovalConfigPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPreApprovalConfig(preApprovalConfigPatchRequest: PreApprovalConfigPatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreApprovalConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPreApprovalConfig(preApprovalConfigPatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreApprovalControllerApi.patchPreApprovalConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fully replaces the pre-approval configuration with the provided one. All fields are required. The sampling probability must be between 0.0 and 1.0.
         * @summary Replace the pre-approval configuration.
         * @param {PreApprovalConfigPutRequest} preApprovalConfigPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPreApprovalConfig(preApprovalConfigPutRequest: PreApprovalConfigPutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreApprovalConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPreApprovalConfig(preApprovalConfigPutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PreApprovalControllerApi.putPreApprovalConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PreApprovalControllerApi - factory interface
 */
export const PreApprovalControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PreApprovalControllerApiFp(configuration)
    return {
        /**
         * Get the current pre-approval configuration.
         * @summary Get the current pre-approval configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreApprovalConfig(options?: RawAxiosRequestConfig): AxiosPromise<PreApprovalConfig> {
            return localVarFp.getPreApprovalConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * Partially updates the pre-approval configuration. Only the provided fields are changed. The sampling probability must be between 0.0 and 1.0.
         * @summary Update the pre-approval configuration.
         * @param {PreApprovalConfigPatchRequest} preApprovalConfigPatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPreApprovalConfig(preApprovalConfigPatchRequest: PreApprovalConfigPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreApprovalConfig> {
            return localVarFp.patchPreApprovalConfig(preApprovalConfigPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fully replaces the pre-approval configuration with the provided one. All fields are required. The sampling probability must be between 0.0 and 1.0.
         * @summary Replace the pre-approval configuration.
         * @param {PreApprovalConfigPutRequest} preApprovalConfigPutRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPreApprovalConfig(preApprovalConfigPutRequest: PreApprovalConfigPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreApprovalConfig> {
            return localVarFp.putPreApprovalConfig(preApprovalConfigPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PreApprovalControllerApi - interface
 */
export interface PreApprovalControllerApiInterface {
    /**
     * Get the current pre-approval configuration.
     * @summary Get the current pre-approval configuration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPreApprovalConfig(options?: RawAxiosRequestConfig): AxiosPromise<PreApprovalConfig>;

    /**
     * Partially updates the pre-approval configuration. Only the provided fields are changed. The sampling probability must be between 0.0 and 1.0.
     * @summary Update the pre-approval configuration.
     * @param {PreApprovalConfigPatchRequest} preApprovalConfigPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchPreApprovalConfig(preApprovalConfigPatchRequest: PreApprovalConfigPatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreApprovalConfig>;

    /**
     * Fully replaces the pre-approval configuration with the provided one. All fields are required. The sampling probability must be between 0.0 and 1.0.
     * @summary Replace the pre-approval configuration.
     * @param {PreApprovalConfigPutRequest} preApprovalConfigPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    putPreApprovalConfig(preApprovalConfigPutRequest: PreApprovalConfigPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreApprovalConfig>;

}

/**
 * PreApprovalControllerApi - object-oriented interface
 */
export class PreApprovalControllerApi extends BaseAPI implements PreApprovalControllerApiInterface {
    /**
     * Get the current pre-approval configuration.
     * @summary Get the current pre-approval configuration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPreApprovalConfig(options?: RawAxiosRequestConfig) {
        return PreApprovalControllerApiFp(this.configuration).getPreApprovalConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Partially updates the pre-approval configuration. Only the provided fields are changed. The sampling probability must be between 0.0 and 1.0.
     * @summary Update the pre-approval configuration.
     * @param {PreApprovalConfigPatchRequest} preApprovalConfigPatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchPreApprovalConfig(preApprovalConfigPatchRequest: PreApprovalConfigPatchRequest, options?: RawAxiosRequestConfig) {
        return PreApprovalControllerApiFp(this.configuration).patchPreApprovalConfig(preApprovalConfigPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fully replaces the pre-approval configuration with the provided one. All fields are required. The sampling probability must be between 0.0 and 1.0.
     * @summary Replace the pre-approval configuration.
     * @param {PreApprovalConfigPutRequest} preApprovalConfigPutRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public putPreApprovalConfig(preApprovalConfigPutRequest: PreApprovalConfigPutRequest, options?: RawAxiosRequestConfig) {
        return PreApprovalControllerApiFp(this.configuration).putPreApprovalConfig(preApprovalConfigPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

